import { Icon, IconName } from '@hills-design-system/components';
import clsx from 'clsx';

export interface TooltipProps {
  content: React.ReactNode;
  align?: 'left' | 'center' | 'right' | 'top';
  size?: number;
  textClasses?: string;
  icon?: IconName;
  children?: React.ReactNode;
  tooltipClassName?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  align = 'center',
  size = 20,
  textClasses = '',
  icon = IconName.InfoOutline,
  children,
  tooltipClassName = '',
}) => {
  return (
    <div className="relative w-max flex-col justify-center items-center group">
      {children ? (
        <div className="cursor-pointer">{children}</div>
      ) : (
        <Icon icon={icon} size={size} className={clsx('cursor-pointer', textClasses)} />
      )}
      <div className="relative z-50 scale-0 transform transition-all delay-100 group-hover:scale-100">
        <div
          className={clsx(
            'absolute',
            {
              'bottom-6 -translate-x-1/2': align === 'top',
              'top-2': align !== 'top',
            },
            'transform',
            'select-none',
            'rounded-200',
            'bg-gray-675',
            'color-accent-primary-background-gray',
            'text-sm',
            'font-normal',
            'text-white',
            'shadow-md',
            'text-left',
            {
              '-translate-x-full': align === 'left',
              '-translate-x-1/2': align === 'center',
            },
            tooltipClassName
          )}
        >
          {content}
        </div>
      </div>
    </div>
  );
};
